<template>
	<div class="instruments">
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Instrumenty</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small>
					<br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div class="instruments__columns">
			<div class="instruments__left">
				<h4 class="instruments__left-header">Instrumenty na stoliku lekarza</h4>
				<small class="instruments__left-hint"></small>
				<NumberedSelectGroup
					:selects="instrumentSelects"
					unitConfigurationProp="instruments"
					configurationPropSetter="setInstruments"
					:groups="instrumentsGroups"
					:useOnlyFirstEnabledFeature="false"
				/>
				<h4 class="instruments__left-header">Akcesoria stolika lekarza</h4>
				<small class="instruments__left-hint instruments__left-hint--smaller-gap"
					>Możesz wybrać dowolną liczbę:</small
				>
				<div class="instruments__options">
					<div class="instruments__radios">
						<Radio
							class="instruments__radio"
							v-for="(accessory, index) in radios"
							name="instruments"
							:value="accessory.name"
							@change="updateAccessories"
							:checked="accessories.includes(accessory.name)"
							:key="`radio__${index}`"
							:checkbox="true"
							:emitValueOnUncheck="true"
							:onmouseover="() => setHighlightedPhysicianTableAccessory(accessory.name)"
							:onmouseleave="unsetHighlightedPhysicianTableAccessory"
						>
							<span class="instruments__radio-label">{{ accessory.fullName }}</span>
							<span class="instruments__radio-cost" slot="right-addon">
								{{ formatPrice(accessory.cost) }}
							</span>
						</Radio>
					</div>
				</div>

				<h4 class="instruments__left-header">Końcówki</h4>
				<small class="instruments__left-hint">
					Możesz wybrać dowolną liczbę:
				</small>

				<div class="instruments__options">
					<div class="instruments__radios">
						<RadioWithNumber
							class="instruments__radio"
							v-for="(tip, index) in tipRadios"
							name="instruments"
							:value="tip.name"
							@change="updateTips"
							:checked="tips.includes(tip.name)"
							:number="tips.filter(t => t === tip.name).length"
							:key="`instrument-tip__${index}`"
							:checkbox="true"
							:emitValueOnUncheck="true"
						>
							<span class="instruments__radio-label">{{ tip.fullName }}</span>
							<span class="instruments__radio-cost" slot="right-addon">
								{{ formatPrice(tip.cost) }}
							</span>
							<Tooltip v-if="tip.tooltip_text" :text="tip.tooltip_text" slot="right-addon-2" />
						</RadioWithNumber>
					</div>
				</div>
			</div>

			<div class="instruments__right">
				<img class="instruments__table-img" :src="tableImg" />
				<div v-if="physicianTableAccessoryImgSrc">
					<img class="instruments__accessory-img" :src="physicianTableAccessoryImgSrc" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import {mapState} from 'vuex';
import {mapUnitConfiguration} from '@/core/helpers/map-unit-configuration.helpers';
import {calculateTableImageNumber} from '@/core/helpers/table-image-number.helpers';
import NumberedSelectGroup from '../NumberedSelectGroup';
import Radio from '../Radio';
import RadioWithNumber from '../RadioWithNumber';
import Tooltip from '../Tooltip';
import hoseOrientationsToAccessories from '../../data/hose-orientations-to-accessories';

const allInstruments = [
	[
		'01',
		'02',
		'03',
		'04',
		'05',
		'06',
		'07',
		'08',
		'09',
		'10',
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'27',
	],
	[
		'01',
		'02',
		'03',
		'04',
		'05',
		'06',
		'07',
		'08',
		'09',
		'10',
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'27',
	],
	[
		'01',
		'02',
		'03',
		'04',
		'05',
		'06',
		'07',
		'08',
		'09',
		'10',
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'27',
	],
	[
		'01',
		'02',
		'03',
		'04',
		'05',
		'06',
		'07',
		'08',
		'09',
		'10',
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'27',
	],
	[
		'01',
		'02',
		'03',
		'04',
		'05',
		'06',
		'07',
		'08',
		'09',
		'10',
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'27',
	],
	[
		'01',
		'02',
		'03',
		'04',
		'05',
		'06',
		'07',
		'08',
		'09',
		'10',
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'20',
		'21',
		'22',
		'23',
		'24',
		'25',
		'26',
		'27',
	],
];

export default {
	name: 'Instruments',
	mixins: [AppDataMixin],
	data() {
		return {
			instrumentSelects: [],
			radios: [],
			instrumentsGroups: {},
			assistantAccessorySelects: [],
			highlightedPhysicianTableAccessory: null,
			tipRadios: [],
		};
	},
	components: {NumberedSelectGroup, Radio, RadioWithNumber, Tooltip},
	computed: {
		...mapState('unitConfiguration', {
			accessories: 'physicianTableAccessories',
			tips: 'instrumentTips',
		}),
		tableImg() {
			const tableImageNumber = calculateTableImageNumber(
				this.hoseOrientation.name,
				this.instrumentCount.name
			);

			return require(`@/assets/pictures/stolik-${tableImageNumber}.jpg`);
		},
		physicianTableAccessoryImgSrc() {
			const selectedAccessory = this.radios.find(
				accessory => accessory.name === this.highlightedPhysicianTableAccessory
			);
			if (selectedAccessory && selectedAccessory.img !== null) {
				return require(`@/assets/pictures/${selectedAccessory.img}`);
			}
			return null;
		},
	},
	mounted() {
		const instruments = this.getAppData('instruments');
		const count = this.instrumentCount.name;
		this.instrumentsGroups = this.getAppData('instrumentsGroups');
		this.instrumentSelects = R.pipe(
			R.map(
				R.pipe(
					R.map(n => instruments[`instrument-${n}`]),
					R.reject(R.isNil)
				)
			),
			R.when(() => count < 6, R.slice(0, count))
		)(allInstruments);
		// for now it doesn't filter anything to be honest, but this logic may come back

		const accessories = this.getAppData('physicianTableAccessories');
		this.radios = R.pipe(
			R.path([this.unit.name, this.hoseOrientation.name]),
			R.map(n => accessories[`pta-${n}`])
		)(hoseOrientationsToAccessories);

		this.tipRadios = this.getAppData('instrumentTips');
	},
	methods: {
		updateTips(tip) {
			tip[1] = parseInt(tip[1], 10);
			const newTips = this.tips.includes(tip[0])
				? R.pipe(
						R.reject(R.equals(tip[0])),
						R.when(
							() => this.tips.filter(t => t === tip[0]).length !== tip[1],
							R.concat(R.repeat(tip[0], tip[1]))
						)
				  )(this.tips)
				: R.concat(R.repeat(tip[0], tip[1]), this.tips);

			this.$store.commit('unitConfiguration/setInstrumentTips', newTips);
		},
		updateAccessories(accessory) {
			const hoseOrientation = this.hoseOrientation.name;

			/*const mutuallyExclusiveNames =
				hoseOrientation === 'up' ? R.pipe(R.pluck('name'), R.slice(3, 5))(this.radios) : [];*/

			const accessoryGroup = R.pipe(
				R.find(r => r.name === accessory),
				R.prop('group')
			)(this.radios);
			const isAccessoryExclusive = !!accessoryGroup;

			const mutuallyExclusiveNames = R.pipe(
				R.filter(R.startsWith('pta-')),
				R.map(a => this.radios.find(r => r.name === a)),
				R.filter(R.propEq('group', accessoryGroup || {})),
				R.pluck('name')
			)(this.accessories);

			let newAccessories = this.accessories.includes(accessory)
				? R.without([accessory], this.accessories)
				: R.pipe(
						R.when(() => isAccessoryExclusive, R.without(mutuallyExclusiveNames)),
						R.append(accessory)
				  )(this.accessories);

			if (
				R.pipe(
					R.and(newAccessories.includes('pta-12')),
					R.and(!newAccessories.includes('pta-01'))
				)(this.unit.name === 'chirana-effective')
			) {
				newAccessories = R.without(['pta-12'], newAccessories);
			}

			if (
				R.pipe(
					R.and(!newAccessories.includes('pta-02')),
					R.and(!newAccessories.includes('pta-03'))
				)(this.unit.name === 'chirana-easy')
			) {
				newAccessories = R.append('pta-02', newAccessories);
			}

			this.$store.commit('unitConfiguration/setPhysicianTableAccessories', newAccessories);
		},
		setHighlightedPhysicianTableAccessory(accessoryName) {
			this.highlightedPhysicianTableAccessory = accessoryName;
		},
		unsetHighlightedPhysicianTableAccessory() {
			this.highlightedPhysicianTableAccessory = null;
		},
	},
};
</script>
